/* הפרומפטים לסריקה ולסיווג. נבנים בצד הלקוח כי הם תלויים בקטגוריות ובהיסטוריה של המשתמש */
import { cats } from '../categories.js';
import { merchantHints } from '../merchants.js';
import { todayISO } from '../../lib/format.js';

export function buildScanPrompt(mode = 'all') {
  const today = todayISO();
  const yr = new Date().getFullYear();
  const cE = cats('expense').map((c) => '  ' + c.id + ' = ' + c.label + (c.keywords ? ' (' + c.keywords + ')' : '')).join('\n');
  const cI = cats('income').map((c) => '  ' + c.id + ' = ' + c.label).join('\n');
  const hints = merchantHints(60);

  let p =
    'אתה מחלץ עסקאות ממסמכים פיננסיים ישראליים: דפי בנק, פירוטי אשראי, קבלות וחשבוניות.\n' +
    'החזר JSON בלבד, בלי טקסט לפני או אחרי.\n\n' +
    '== איזה סכום לקחת ==\n' +
    'זהה את העמודה שמייצגת את מה שחויב בפועל מהחשבון או מהכרטיס.\n' +
    'כשיש כמה עמודות סכום, בחר את זו שבמטבע המקומי ואחרי המרה או עמלות, לא את סכום העסקה המקורי.\n' +
    'בקבלה של חנות: קח את סכום השורה (כמות × מחיר), ואם מבקשים סיכום בלבד קח את השורה הסופית לתשלום.\n' +
    'בחשבונית: הסכום כולל מע"מ.\n' +
    'מטבע זר: אם מופיע סכום בשקלים אחרי המרה, קח אותו. אם לא, המר לפי השער שמופיע במסמך.\n' +
    'תשלומים: קח את התשלום הנוכחי בלבד, לא את סכום העסקה המלא.\n' +
    'הסכום תמיד חיובי. הכיוון נקבע בשדה type.\n\n' +
    '== תאריכים ==\n' +
    'פלט תמיד YYYY-MM-DD.\n' +
    'DD.MM.YY: שנה דו ספרתית שייכת למאה הנוכחית (' + String(yr).slice(0, 2) + 'YY).\n' +
    'מספר שלם בטווח 40000-50000 הוא תאריך סריאלי של אקסל: 30.12.1899 ועוד N ימים.\n' +
    'שמות חודשים בעברית או באנגלית, מלאים או מקוצרים, תקינים.\n' +
    'אם יש רק חודש ושנה, השתמש ביום 1.\n' +
    'אם מופיעים גם תאריך עסקה וגם תאריך חיוב עתידי, קח את תאריך העסקה.\n' +
    'אם אין תאריך כלל: ' + today + '\n\n' +
    '== ניקוי תיאורים ==\n' +
    'המטרה: שם עסק קריא בלבד.\n' +
    'הסר מהתיאור מספרי אסמכתא, קודי סניף, מספרי קופה, ותווי כיוון בלתי נראים. את האסמכתא עצמה אל תזרוק, היא נכנסת לשדה ref.\n' +
    'טקסט עברי שנשמר בכיוון הפוך הוא תקלה נפוצה בקבצי אשראי. קרא כל מחרוזת עברית גם מהסוף להתחלה, ובחר את הגרסה שמרכיבה מילים אמיתיות בעברית.\n' +
    'כשיש קו נטוי בין מספר לשם, המספר הוא קוד והשם הוא העסק.\n' +
    'שמות מותג לועזיים: השאר באנגלית אם זו הצורה המוכרת, והסר מספרים נלווים.\n' +
    'אותו עסק בכתיבים שונים צריך לקבל תיאור זהה בכל השורות.\n\n' +
    '== סיווג לקטגוריה ==\n' +
    'קטגוריות הוצאה הקיימות אצל המשתמש:\n' + cE + '\n' +
    'קטגוריות הכנסה:\n' + cI + '\n' +
    (hints ? 'עסקים שהמשתמש כבר סיווג בעבר. אם עסק מופיע ברשימה, השתמש בסיווג הזה גם אם היית בוחר אחרת:\n' + hints + '\n' : '') +
    'הסיווג נעשה לפי מה שהעסק מוכר בפועל, לא לפי שמו.\n' +
    'המילים בסוגריים הן רמזים שהמשתמש הגדיר בעצמו, ויש להן עדיפות על ההיגיון הכללי שלך.\n' +
    'אם אף קטגוריה לא מתאימה ואתה מזהה נושא שחוזר על עצמו במסמך, פתח קטגוריה חדשה:\n' +
    '  isNewCat:true, cat:"מזהה_באנגלית_קצר", newCatIcon:"אימוג׳י אחד"\n' +
    'קטגוריה חדשה רק לנושא שמופיע יותר מפעם אחת. לשורה בודדת וחריגה השתמש ב-other.\n\n' +
    '== פעולות פנימיות ==\n' +
    'חלק מהשורות אינן הוצאה או הכנסה אמיתית אלא תנועת כסף בתוך הכספים של אותו אדם:\n' +
    'העברה בין חשבונות של אותו בעלים, משיכת מזומן, הפקדה, קבלת הלוואה, העברה לחיסכון או להשקעה,\n' +
    'וזוג חיוב וזיכוי זהים מאותו מקור שמתקזז לאפס.\n' +
    'אל תשמיט אותן. החזר אותן עם internal:true, וכל השאר internal:false.\n' +
    'תשלום החזר הלוואה או משכנתא הוא הוצאה אמיתית, לא פעולה פנימית.\n\n' +
    '== מה באמת לדלג ==\n' +
    'שורות כותרת, שורות ריקות, שורות סיכום וסך הכל, ושורות בסכום אפס.\n' +
    'שורה שמופיעה פעמיים עם אותה אסמכתא היא אותה עסקה, החזר אותה פעם אחת.\n\n' +
    '== דיוק ==\n' +
    'במסמך סרוק ספרות עלולות להשתבש. בדוק שהסכום סביר ביחס לשאר השורות.\n' +
    'בטבלה ללא קווי הפרדה, זהה עמודות לפי יישור.\n' +
    'אל תמציא ערך שאינו במסמך. אם שדה לא ברור, השאר את התיאור כפי שהוא ותן את הסיווג הסביר ביותר.\n\n';

  if (mode === 'summary') {
    p += '== פלט ==\nהמסמך הוא קבלה או חשבונית אחת. החזר אובייקט JSON יחיד עם הסכום הסופי לתשלום:\n' +
      '{"description":"שם העסק","amount":0,"type":"expense","cat":"food","date":"' + today + '","internal":false,"isNewCat":false,"newCatIcon":"📦"}\n';
  } else {
    p += '== מזהים לזיהוי כפילויות ==\n' +
      'ref: מספר אסמכתא או מספר שובר של השורה, בדיוק כפי שהוא. אם אין, מחרוזת ריקה.\n' +
      'card4: 4 הספרות האחרונות של הכרטיס שהעסקה שייכת אליו, אם מופיעות במסמך. אחרת ריק.\n' +
      'raw: שם בית העסק בדיוק כפי שהוא כתוב במסמך, לפני כל ניקוי.\n' +
      'orig: לעסקה במטבע זר, הסכום והמטבע המקוריים, למשל "12.50 USD". לעסקה בשקלים ריק.\n' +
      'אל תמציא מזהה שאינו כתוב במסמך.\n\n' +
      '== פלט ==\n' +
      'החזר שורה אחת במערך לכל עסקה במסמך, בלי לאחד ובלי לסנן.\n' +
      'שורות שנראות זהות הן עסקאות נפרדות והן נשארות נפרדות.\n' +
      '[{"description":"שם העסק","amount":0,"type":"expense","cat":"food","date":"' + today + '","internal":false,"isNewCat":false,"newCatIcon":"📦","ref":"","card4":"","raw":"","orig":""}]\n';
  }
  return p;
}

export function buildClassifyPrompt(names) {
  const cE = cats('expense').map((c) => '  ' + c.id + ' = ' + c.label + (c.keywords ? ' (' + c.keywords + ')' : '')).join('\n');
  const cI = cats('income').map((c) => '  ' + c.id + ' = ' + c.label).join('\n');
  return 'לפניך רשימת שמות בתי עסק מדף אשראי או מדף בנק ישראלי. סווג כל אחד.\n\n' +
    '== קטגוריות הוצאה ==\n' + cE + '\n' +
    '== קטגוריות הכנסה ==\n' + cI + '\n\n' +
    '== ניקוי השם ==\n' +
    'השמות כבר עברו תיקון כיוון ועברית אוטומטי לפני שהגיעו אליך, והם בסדר הנכון.\n' +
    'אסור להפוך אותיות, להזיז אותיות או לשנות את סדר המילים.\n' +
    'מותר רק להסיר מספרי אסמכתא, קודי סניף ומספרי חשבון, ולהשאיר את שם הגורם כפי שהוא.\n' +
    'כשיש קו נטוי, בחר את המקטע שהוא שם ולא מספר, והשאר אותו מילה במילה.\n' +
    'שם קטוע נשאר קטוע. אל תשלים אותו.\n' +
    'אם אינך בטוח, החזר ב-clean בדיוק את השם שקיבלת.\n\n' +
    '== סיווג ==\n' +
    'לפי מה שהעסק מוכר בפועל, לא לפי שמו. המילים בסוגריים הן רמזים שהמשתמש הגדיר, ויש להן עדיפות.\n' +
    'אם אין קטגוריה מתאימה ומדובר בנושא שחוזר, פתח חדשה: isNewCat:true, cat:"מזהה_באנגלית", newCatIcon:"אימוג׳י".\n' +
    'לשם בודד וחריג השתמש ב-other.\n\n' +
    '== פעולות פנימיות ==\n' +
    'עסק שמייצג תנועה בתוך הכספים של אותו אדם ולא הוצאה אמיתית, למשל משיכת מזומן, כספומט,\n' +
    'העברה בין חשבונות, רכישת מטבע דיגיטלי או העברה לחיסכון והשקעה: סמן internal:true.\n\n' +
    '== פלט ==\n' +
    'מערך JSON בלבד, איבר אחד לכל שם ברשימה, באותו סדר. בלי טקסט נוסף.\n' +
    'שדה name חייב להיות השם המקורי בדיוק כפי שקיבלת אותו. הגרסה המנוקה נכנסת לשדה clean.\n' +
    '[{"name":"השם המקורי","clean":"שם נקי","cat":"food","type":"expense","internal":false,"isNewCat":false,"newCatIcon":"📦"}]\n\n' +
    '== השמות לסיווג ==\n' +
    names.map((n, i) => i + 1 + '. ' + n).join('\n');
}

/** סיווג עסקים שב"אחר" (מסך הסיווג) */
export function buildSuggestPrompt(list) {
  const cs = cats('expense').filter((c) => c.id !== 'other');
  return 'סווג בתי עסק ישראליים לקטגוריות הוצאה של משק בית.\n' +
    'קטגוריות (id=שם): ' + cs.map((c) => c.id + '=' + c.label + (c.keywords ? ' (' + c.keywords + ')' : '')).join(', ') + '\n' +
    'אם אין התאמה ברורה, החזר "other". החזר רק JSON: [{"i":0,"cat":"food"}]\n' +
    list.map((e, i) => i + ': ' + e.name).join('\n');
}
